import React from 'react';
import { styled } from '@compiled/react';
import CalendarIcon from '@atlaskit/icon/glyph/calendar';
import CommentIcon from '@atlaskit/icon/glyph/comment';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { STYLES } from '../constants';
import messages from '../messages';

export const ProductFeatureList = () => {
	const { formatMessage } = useIntl();

	return (
		<UnorderedList>
			{items.map(({ getIcon, message }, index: number) => (
				<ListItem key={index}>
					{getIcon()}
					<Box
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
						xcss={xcss({
							marginLeft: 'space.100',
						})}
					>
						{formatMessage(message)}
					</Box>
				</ListItem>
			))}
		</UnorderedList>
	);
};

const items = [
	{
		getIcon: () => (
			<FixedSizeSvg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				color={STYLES.modal.colors.purple}
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M12 20C10.9494 20 9.90914 19.7931 8.93853 19.391C7.96793 18.989 7.08601 18.3997 6.34315 17.6569C5.60028 16.914 5.011 16.0321 4.60896 15.0615C4.20693 14.0909 4 13.0506 4 12C4 10.9494 4.20693 9.90914 4.60896 8.93853C5.011 7.96793 5.60028 7.08601 6.34315 6.34315C7.08601 5.60028 7.96793 5.011 8.93853 4.60896C9.90914 4.20693 10.9494 4 12 4C14.1217 4 16.1566 4.84285 17.6569 6.34315C19.1571 7.84344 20 9.87827 20 12C20 14.1217 19.1571 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20ZM12 18.2857C13.6671 18.2857 15.2659 17.6235 16.4447 16.4447C17.6235 15.2659 18.2857 13.6671 18.2857 12C18.2857 10.3329 17.6235 8.73413 16.4447 7.55533C15.2659 6.37653 13.6671 5.71429 12 5.71429C10.3329 5.71429 8.73413 6.37653 7.55533 7.55533C6.37653 8.73413 5.71429 10.3329 5.71429 12C5.71429 13.6671 6.37653 15.2659 7.55533 16.4447C8.73413 17.6235 10.3329 18.2857 12 18.2857ZM12 11.4286C12.3031 11.4286 12.5938 11.549 12.8081 11.7633C13.0224 11.9776 13.1429 12.2683 13.1429 12.5714V14.8571C13.1429 15.1602 13.0224 15.4509 12.8081 15.6653C12.5938 15.8796 12.3031 16 12 16C11.6969 16 11.4062 15.8796 11.1919 15.6653C10.9776 15.4509 10.8571 15.1602 10.8571 14.8571V12.5714C10.8571 12.2683 10.9776 11.9776 11.1919 11.7633C11.4062 11.549 11.6969 11.4286 12 11.4286ZM12 8C12.3031 8 12.5938 8.12041 12.8081 8.33474C13.0224 8.54906 13.1429 8.83975 13.1429 9.14286C13.1429 9.44596 13.0224 9.73665 12.8081 9.95098C12.5938 10.1653 12.3031 10.2857 12 10.2857C11.6969 10.2857 11.4062 10.1653 11.1919 9.95098C10.9776 9.73665 10.8571 9.44596 10.8571 9.14286C10.8571 8.83975 10.9776 8.54906 11.1919 8.33474C11.4062 8.12041 11.6969 8 12 8Z"
					fill="currentColor"
				/>
			</FixedSizeSvg>
		),
		message: messages.contextToAnythingFeatureNoTranslate,
	},
	{
		getIcon: () => (
			<CommentIcon
				size="medium"
				label="Comment bubble icon"
				primaryColor={STYLES.modal.colors.purple}
			/>
		),
		message: messages.updateYourTeamNoTranslate,
	},
	{
		getIcon: () => (
			<CalendarIcon size="medium" label="Calendar icon" primaryColor={STYLES.modal.colors.purple} />
		),
		message: messages.freeTrialNoTranslate,
	},
];

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const ListItem = styled.li({
	display: 'flex',
	alignItems: 'center',
	marginTop: token('space.250', '20px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const FixedSizeSvg = styled.svg({
	flexShrink: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const UnorderedList = styled.ul({
	listStyle: 'none',
	padding: 0,
	marginTop: token('space.250', '24px'),
});
